import { NgModule } from '@angular/core';
import { FooterNonMedicalComponent } from './footer-non-medical.component';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    imports: [
        BaseModule,
        MatSelectModule,
        BsDropdownModule.forRoot(),
        StoryBlokLinkModule
    ],
    declarations: [
        FooterNonMedicalComponent
    ],
    exports: [
        FooterNonMedicalComponent
    ]
})
export class FooterNonMedicalModule { }
